import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

import type { FC } from 'react'

interface PageGuardGpkTimKinerjaProps
  extends React.HTMLAttributes<HTMLDivElement> {
  allowOtherRoles?: boolean
}

export const PageGuardGpkTimKinerja: FC<PageGuardGpkTimKinerjaProps> = ({
  children,
  allowOtherRoles = false,
}) => {
  const { isLoading: isLoadingRole, isGpkTimKinerja, leave } = useRoleContext()

  // As the component should not be rendered when still loading the user role, we can just return null
  if (isLoadingRole) return null

  if (!isGpkTimKinerja && !allowOtherRoles) {
    leave()
    return null
  }

  return <>{children}</>
}
